import type { LabelColorKey } from '@cw/shared';
import { cn, initials } from '@/lib/utils';

const SIZES = {
  sm: 'size-8 rounded-[9px] text-[11.5px]',
  md: 'size-11 rounded-[12px] text-[14px]',
  lg: 'size-16 rounded-[16px] text-[20px]',
  xl: 'size-20 rounded-[20px] text-[24px]',
};

/** Marca do cliente: logo quando existe; senão, iniciais na cor de identidade. */
export function ClientMark({
  name,
  color,
  logoUrl,
  size = 'md',
  className,
}: {
  name: string;
  color: LabelColorKey;
  logoUrl: string | null;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  const v = `var(--color-label-${color})`;
  return (
    <span
      className={cn(
        'relative inline-flex shrink-0 items-center justify-center overflow-hidden font-semibold tracking-tight',
        SIZES[size],
        className,
      )}
      style={{
        background: logoUrl ? '#f4f4f5' : `color-mix(in srgb, ${v} 18%, var(--color-raised))`,
        color: v,
      }}
    >
      {logoUrl ? (
        <img src={logoUrl} alt="" className="size-full object-contain p-[12%]" loading="lazy" />
      ) : (
        initials(name)
      )}
    </span>
  );
}

export const labelVar = (c: LabelColorKey) => `var(--color-label-${c})`;
